import { render, staticRenderFns } from "./reisen-modal-edit.vue?vue&type=template&id=ed6f01d6"
import script from "./reisen-modal-edit.vue?vue&type=script&lang=js"
export * from "./reisen-modal-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports